import CircleRed from "../svg/CircleRed.svg";
import CircleGreen from "../svg/CircleGreen.svg";
import { ProjectTimeLineItemType } from "../PublishProject/types";

type ProjectTimeLineTypeProps = {
  type: ProjectTimeLineItemType;
};
const ProjectTimeLineType = ({ type }: ProjectTimeLineTypeProps) => {
  let src = CircleGreen;
  switch (type) {
    case "deleted":
      src = CircleRed;
  }

  return <img src={src} alt={type} height="14px"></img>;
};

export default ProjectTimeLineType;
